import { TipoUnidadeForcaMuscular } from 'graphql/types.generated'
import { v4 as uuidv4 } from 'uuid'
import { HistoricoMedicaoModel } from 'view/atendimentos/types/model-historicoMedicao'

import { MedicaoAnteriorModel, UNIDADE_FORCA_MUSCULAR } from '../model-medicoes'
import {
  MedicaoAnteriorExameFisicoFormModel,
  MEDICOES_ANTERIORES_EXAME_FISICO,
} from './model-medicaoAnteriorExameFisico'

export function convertMedicaoAnteriorExameFisicoFormModelToMedicaoAnteriorModel(
  medicao: MedicaoAnteriorExameFisicoFormModel
): MedicaoAnteriorModel {
  return {
    id: uuidv4(),
    data: medicao.data,
    valorForcaMuscMaoDireita: medicao.valorForcaMuscMaoDireita,
    unidadeForcaMuscMaoDireita: medicao.unidadeForcaMuscMaoDireita,
    valorForcaMuscMaoEsquerda: medicao.valorForcaMuscMaoEsquerda,
    unidadeForcaMuscMaoEsquerda: medicao.unidadeForcaMuscMaoEsquerda,
  }
}

export function isMedicaoAnteriorExameFisico(medicaoAnterior: HistoricoMedicaoModel): boolean {
  return MEDICOES_ANTERIORES_EXAME_FISICO.some((medicaoExameFisico) => medicaoAnterior[medicaoExameFisico])
}

export function getForcaMuscularRenderText(valor: string | undefined, unidade: TipoUnidadeForcaMuscular | undefined) {
  if (!valor || !unidade) {
    return null
  }

  const { sigla } = UNIDADE_FORCA_MUSCULAR[unidade]

  return `${valor} ${sigla}`
}
